var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-6 col-lg-3" }, [
    _c("div", { staticClass: "ibox kpi-card" }, [
      _c(
        "div",
        { staticClass: "ibox-body text-center", class: _vm.cardClass },
        [
          _c("div", { staticClass: "kpi-icon" }, [
            _c("i", {
              staticClass: "fa-3x",
              class: _vm.icon,
              attrs: {
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: _vm.tooltip,
              },
            }),
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "kpi-value" }, [
            _vm._v(_vm._s(_vm.formatValue(_vm.value))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "kpi-label" }, [_vm._v(_vm._s(_vm.label))]),
          _vm._v(" "),
          _c("small", { staticClass: "kpi-subtitle" }, [
            _vm._v(_vm._s(_vm.subtitle)),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }